import React from 'react';
import {RootRouter} from "./routing/RootRouter";


function App() {
  return (
      <RootRouter />
  );
}

export default App;
